import { Stack } from 'expo-router';

function DirectDepositSetupLayout() {
  return <Stack />;
}

export default DirectDepositSetupLayout;
